var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudDb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 191.43 145.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#407bff;}.cls-4{fill:#fff;}.cls-5{opacity:0.3;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{opacity:0.6;}.cls-8{clip-path:url(#clip-path-4);}.cls-9{clip-path:url(#clip-path-5);}.cls-10{opacity:0.9;}.cls-11{clip-path:url(#clip-path-6);}.cls-12{opacity:0.1;}.cls-13{clip-path:url(#clip-path-7);}.cls-14{clip-path:url(#clip-path-8);}.cls-15{clip-path:url(#clip-path-9);}.cls-16{clip-path:url(#clip-path-10);}.cls-17{clip-path:url(#clip-path-11);}.cls-18{clip-path:url(#clip-path-12);}.cls-19{clip-path:url(#clip-path-13);}.cls-20{clip-path:url(#clip-path-14);}.cls-21{clip-path:url(#clip-path-15);}.cls-22{clip-path:url(#clip-path-16);}.cls-23{clip-path:url(#clip-path-17);}.cls-24{clip-path:url(#clip-path-18);}.cls-25{clip-path:url(#clip-path-19);}.cls-26{clip-path:url(#clip-path-20);}.cls-27{clip-path:url(#clip-path-21);}.cls-28{clip-path:url(#clip-path-22);}.cls-29{clip-path:url(#clip-path-23);}.cls-30{opacity:0.7;}.cls-31{clip-path:url(#clip-path-26);}.cls-32{clip-path:url(#clip-path-27);}.cls-33{clip-path:url(#clip-path-28);}.cls-34{clip-path:url(#clip-path-30);}.cls-35{fill:#e0e0e0;}.cls-36{clip-path:url(#clip-path-31);}.cls-37{clip-path:url(#clip-path-32);}.cls-38{clip-path:url(#clip-path-33);}.cls-39{fill:#ebebeb;}.cls-40{clip-path:url(#clip-path-34);}.cls-41{clip-path:url(#clip-path-35);}.cls-42{clip-path:url(#clip-path-36);}.cls-43{clip-path:url(#clip-path-37);}.cls-44{clip-path:url(#clip-path-38);}.cls-45{clip-path:url(#clip-path-39);}.cls-46{clip-path:url(#clip-path-40);}.cls-47{clip-path:url(#clip-path-41);}.cls-48{clip-path:url(#clip-path-42);}.cls-49{clip-path:url(#clip-path-43);}.cls-50{clip-path:url(#clip-path-44);}.cls-51{clip-path:url(#clip-path-45);}.cls-52{clip-path:url(#clip-path-46);}.cls-53{clip-path:url(#clip-path-47);}.cls-54{clip-path:url(#clip-path-48);}.cls-55{clip-path:url(#clip-path-49);}.cls-56{clip-path:url(#clip-path-50);}.cls-57{clip-path:url(#clip-path-51);}.cls-58{clip-path:url(#clip-path-52);}.cls-59{clip-path:url(#clip-path-53);}.cls-60{clip-path:url(#clip-path-54);}.cls-61{clip-path:url(#clip-path-55);}.cls-62{clip-path:url(#clip-path-56);}.cls-63{clip-path:url(#clip-path-57);}.cls-64{clip-path:url(#clip-path-58);}.cls-65{clip-path:url(#clip-path-59);}.cls-66{clip-path:url(#clip-path-60);}.cls-67{clip-path:url(#clip-path-61);}.cls-68{clip-path:url(#clip-path-62);}.cls-69{clip-path:url(#clip-path-63);}.cls-70{clip-path:url(#clip-path-64);}.cls-71{clip-path:url(#clip-path-65);}.cls-72{clip-path:url(#clip-path-66);}.cls-73{clip-path:url(#clip-path-67);}.cls-74{clip-path:url(#clip-path-68);}.cls-75{clip-path:url(#clip-path-69);}.cls-76{clip-path:url(#clip-path-70);}.cls-77{clip-path:url(#clip-path-71);}.cls-78{clip-path:url(#clip-path-72);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 191.39,
    height: 145.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.49,
    y: 117.23,
    width: 36.24,
    height: 22.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.32,
    y: 141.43,
    width: 15.22,
    height: 4.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.68,
    y: 141.43,
    width: 16.42,
    height: 4.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.2,
    y: 118.18,
    width: 34.83,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.87,
    y: 118.18,
    width: 12.19,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.01,
    y: 118.18,
    width: 10.27,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.71,
    y: 118.18,
    width: 10.27,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.25,
    y: 117.23,
    width: 36.24,
    height: 22.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.08,
    y: 141.43,
    width: 15.22,
    height: 4.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 83.44,
    y: 141.43,
    width: 16.42,
    height: 4.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.95,
    y: 118.18,
    width: 34.83,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.63,
    y: 118.18,
    width: 12.19,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.76,
    y: 118.18,
    width: 10.27,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.46,
    y: 118.18,
    width: 10.27,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127,
    y: 117.23,
    width: 36.24,
    height: 22.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.84,
    y: 141.43,
    width: 15.22,
    height: 4.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.19,
    y: 141.43,
    width: 16.42,
    height: 4.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.71,
    y: 118.18,
    width: 34.83,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.39,
    y: 118.18,
    width: 12.19,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 138.52,
    y: 118.18,
    width: 10.27,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 148.22,
    y: 118.18,
    width: 10.27,
    height: 20.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.57,
    y: 0.52,
    width: 164.82,
    height: 97.97
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,31.17a33.7,33.7,0,0,0,2.19,67.32H141.46A23.89,23.89,0,0,0,150,52.28a32.41,32.41,0,0,0-44.53-29.77A39.16,39.16,0,0,0,32,31.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.57,
    y: 0.53,
    width: 164.82,
    height: 97.97
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 165.87,
    height: 99.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 57.03,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 54.72,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 52.4,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 64.08,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 61.76,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 75.76,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 73.44,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 71.13,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 85.13,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 82.81,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 80.49,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 94.49,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 92.17,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.43,
    y: 89.86,
    width: 9.59,
    height: 1.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 37.7,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 34.29,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 30.88,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 51.49,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 48.08,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 44.67,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 65.28,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 61.87,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 58.45,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 79.06,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 72.24,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 92.85,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 89.44,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.98,
    y: 86.03,
    width: 14.12,
    height: 2.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 45.55,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 42.59,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 39.62,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 54.58,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 51.61,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 69.53,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 66.57,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 63.6,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 81.53,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 78.56,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 75.59,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 93.52,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 90.55,
    width: 12.28,
    height: 2.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72",
    transform: "translate(0.04 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.8,
    y: 87.58,
    width: 12.28,
    height: 2.28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    className: "cls-3",
    d: "M25,137.7l1.05-18.52a2.1,2.1,0,0,1,2.08-2h30A1.82,1.82,0,0,1,60,119v.15L59,137.7a2.11,2.11,0,0,1-2.07,2h-30A1.83,1.83,0,0,1,25,137.85v-.15",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    className: "cls-4",
    d: "M23.5,137.7l1.06-18.52a2.09,2.09,0,0,1,2.07-2H57.88a1.82,1.82,0,0,1,1.85,1.8v.15L58.67,137.7a2.11,2.11,0,0,1-2.08,2H25.35a1.85,1.85,0,0,1-1.86-1.81.76.76,0,0,1,0-.15",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    className: "cls-3",
    d: "M23.5,137.7l1.06-18.52a2.09,2.09,0,0,1,2.07-2H57.88a1.82,1.82,0,0,1,1.85,1.8v.15L58.67,137.7a2.11,2.11,0,0,1-2.08,2H25.35a1.85,1.85,0,0,1-1.86-1.81.76.76,0,0,1,0-.15",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    className: "cls-3",
    d: "M36.32,143.64v-.25a2,2,0,0,1,2-2h11.3a2,2,0,0,1,2,2v.25a2,2,0,0,1-1.95,2H38.28a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    className: "cls-4",
    d: "M36.32,143.64v-.25a2,2,0,0,1,2-2h11.3a2,2,0,0,1,2,2v.25a2,2,0,0,1-1.95,2H38.28a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    className: "cls-4",
    d: "M31.68,143.64v-.25a2,2,0,0,1,2-2H46.15a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2H33.64a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    className: "cls-3",
    d: "M31.68,143.64v-.25a2,2,0,0,1,2-2H46.15a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2H33.64a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    className: "cls-4",
    d: "M57,138.71H25a.8.8,0,0,1-.81-.8v-.07L25.28,119a.92.92,0,0,1,.91-.86h32A.8.8,0,0,1,59,119a.17.17,0,0,1,0,.07L58,137.84a.93.93,0,0,1-.92.87",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    className: "cls-3",
    d: "M34.24,138.71H27.87l5.83-20.53h6.37Z",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    className: "cls-3",
    d: "M39.46,138.71H35l5.82-20.53h4.45Z",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    className: "cls-3",
    d: "M49.16,138.71H44.71l5.82-20.53H55Z",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    className: "cls-3",
    d: "M76.77,137.7l1.06-18.52a2.1,2.1,0,0,1,2.07-2H110a1.82,1.82,0,0,1,1.85,1.8.86.86,0,0,1,0,.16l-1.06,18.51a2.09,2.09,0,0,1-2.07,2h-30a1.83,1.83,0,0,1-1.85-1.81v-.15",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    className: "cls-4",
    d: "M75.25,137.7l1.06-18.52a2.1,2.1,0,0,1,2.07-2h31.26a1.82,1.82,0,0,1,1.85,1.8.76.76,0,0,1,0,.15l-1.06,18.52a2.09,2.09,0,0,1-2.07,2H77.1a1.83,1.83,0,0,1-1.85-1.81v-.15",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    className: "cls-3",
    d: "M75.25,137.7l1.06-18.52a2.1,2.1,0,0,1,2.07-2h31.26a1.82,1.82,0,0,1,1.85,1.8.76.76,0,0,1,0,.15l-1.06,18.52a2.09,2.09,0,0,1-2.07,2H77.1a1.83,1.83,0,0,1-1.85-1.81v-.15",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    className: "cls-3",
    d: "M88.08,143.64v-.25a2,2,0,0,1,2-2h11.3a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2H90a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    className: "cls-4",
    d: "M88.08,143.64v-.25a2,2,0,0,1,2-2h11.3a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2H90a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    className: "cls-4",
    d: "M83.44,143.64v-.25a2,2,0,0,1,2-2H97.9a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2H85.4a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    className: "cls-3",
    d: "M83.44,143.64v-.25a2,2,0,0,1,2-2H97.9a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2H85.4a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    className: "cls-4",
    d: "M108.79,138.71h-32a.82.82,0,0,1-.82-.8.2.2,0,0,1,0-.07L77,119a.93.93,0,0,1,.92-.86h32a.8.8,0,0,1,.82.79V119l-1.08,18.8a.93.93,0,0,1-.91.87",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    className: "cls-3",
    d: "M86,138.71H79.63l5.82-20.53h6.37Z",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    className: "cls-3",
    d: "M91.21,138.71H86.76l5.83-20.53H97Z",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    className: "cls-3",
    d: "M100.91,138.71H96.46l5.83-20.53h4.45Z",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    className: "cls-3",
    d: "M128.53,137.7l1.06-18.52a2.09,2.09,0,0,1,2.07-2h30a1.83,1.83,0,0,1,1.86,1.8.76.76,0,0,1,0,.15l-1.06,18.52a2.09,2.09,0,0,1-2.07,2h-30a1.83,1.83,0,0,1-1.85-1.81.76.76,0,0,1,0-.15",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    className: "cls-4",
    d: "M127,137.7l1.06-18.52a2.09,2.09,0,0,1,2.07-2h31.25a1.82,1.82,0,0,1,1.85,1.8v.15l-1.06,18.52a2.11,2.11,0,0,1-2.07,2H128.86a1.84,1.84,0,0,1-1.86-1.81.76.76,0,0,1,0-.15",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    className: "cls-3",
    d: "M127,137.7l1.06-18.52a2.09,2.09,0,0,1,2.07-2h31.25a1.82,1.82,0,0,1,1.85,1.8v.15l-1.06,18.52a2.11,2.11,0,0,1-2.07,2H128.86a1.84,1.84,0,0,1-1.86-1.81.76.76,0,0,1,0-.15",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    className: "cls-3",
    d: "M139.84,143.64v-.25a2,2,0,0,1,1.95-2h11.3a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2h-11.3a2,2,0,0,1-1.95-2",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    className: "cls-4",
    d: "M139.84,143.64v-.25a2,2,0,0,1,1.95-2h11.3a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2h-11.3a2,2,0,0,1-1.95-2",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    className: "cls-4",
    d: "M135.19,143.64v-.25a2,2,0,0,1,2-2h12.51a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2H137.15a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    className: "cls-3",
    d: "M135.19,143.64v-.25a2,2,0,0,1,2-2h12.51a2,2,0,0,1,2,2v.25a2,2,0,0,1-2,2H137.15a2,2,0,0,1-2-2",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    className: "cls-4",
    d: "M160.55,138.71h-32a.8.8,0,0,1-.81-.8v-.07l1.08-18.8a.92.92,0,0,1,.91-.86h32a.8.8,0,0,1,.82.79V119l-1.08,18.8a.93.93,0,0,1-.91.87",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    className: "cls-3",
    d: "M137.75,138.71h-6.36l5.82-20.53h6.37Z",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    className: "cls-3",
    d: "M143,138.71h-4.45l5.82-20.53h4.45Z",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    className: "cls-3",
    d: "M152.67,138.71h-4.45L154,118.18h4.45Z",
    transform: "translate(0.04 0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    className: "cls-3",
    d: "M41.44,113.54l-.1,0-.09-.06a.47.47,0,0,1-.06-.09.36.36,0,0,1,0-.1.32.32,0,0,1,.08-.2.31.31,0,0,1,.29-.06l.09.06a.24.24,0,0,1,.06.09.2.2,0,0,1,0,.11.36.36,0,0,1,0,.1.24.24,0,0,1-.06.09.27.27,0,0,1-.19.08",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    className: "cls-3",
    d: "M41.17,111.28a.27.27,0,1,1,.54,0h0a.27.27,0,1,1-.54,0h0",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    className: "cls-3",
    d: "M41.44,109.58a.25.25,0,0,1-.19-.09.16.16,0,0,1-.06-.08.36.36,0,0,1,0-.1.26.26,0,0,1,.08-.19.25.25,0,0,1,.29-.06.15.15,0,0,1,.09.06.16.16,0,0,1,.06.08.2.2,0,0,1,0,.11.18.18,0,0,1,0,.1.29.29,0,0,1-.15.14.12.12,0,0,1-.1,0",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    className: "cls-3",
    d: "M91.08,109.31a.28.28,0,0,1,.27-.27.27.27,0,0,1,0,.54.28.28,0,0,1-.27-.27h0m-2.17,0a.28.28,0,0,1,.27-.28.28.28,0,0,1,.27.28.28.28,0,0,1-.26.27h0a.28.28,0,0,1-.27-.27m-2.17,0a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.27.27,0,0,1,.54,0h0a.27.27,0,0,1-.54,0h0m-2.17,0a.27.27,0,1,1,.54,0,.28.28,0,0,1-.26.27h0a.28.28,0,0,1-.27-.27m-2.17,0a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.27.27,0,1,1,.27.27.28.28,0,0,1-.27-.27h0m-2.17,0a.27.27,0,1,1,.54,0,.28.28,0,0,1-.26.27h0a.28.28,0,0,1-.27-.27m-2.17,0a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.28.28,0,0,1,.27-.28.28.28,0,1,1-.27.28h0m-2.17,0a.27.27,0,1,1,.54,0,.28.28,0,0,1-.26.27h0a.28.28,0,0,1-.27-.27m-2.17,0a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.27.27,0,1,1,.26.26.27.27,0,0,1-.26-.26m-2.17,0a.27.27,0,1,1,.27.27h0a.28.28,0,0,1-.27-.27m-2.17,0A.28.28,0,0,1,61,109a.27.27,0,0,1,.27.27h0a.28.28,0,0,1-.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.27.27,0,1,1,.54,0,.28.28,0,0,1-.27.28h0a.28.28,0,0,1-.27-.27m-2.17,0a.28.28,0,0,1,.27-.28.27.27,0,0,1,.27.27h0a.28.28,0,0,1-.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.27.27,0,1,1,.27.27h0a.28.28,0,0,1-.27-.27m-2.17,0a.27.27,0,1,1,.27.27h0a.28.28,0,0,1-.27-.27m-2.17,0a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27h0m-2.17,0a.27.27,0,1,1,.27.27h0a.28.28,0,0,1-.27-.27",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    className: "cls-3",
    d: "M93.52,109.57a.12.12,0,0,1-.1,0l-.09,0-.06-.09a.36.36,0,0,1,0-.1.36.36,0,0,1,0-.11l.06-.08a.24.24,0,0,1,.09-.06.26.26,0,0,1,.21,0,.24.24,0,0,1,.09.06.24.24,0,0,1,.08.19.19.19,0,0,1,0,.1.41.41,0,0,1,0,.09l-.09,0a.15.15,0,0,1-.11,0",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    className: "cls-3",
    d: "M93.52,109.57a.12.12,0,0,1-.1,0l-.09,0-.06-.09a.36.36,0,0,1,0-.1.36.36,0,0,1,0-.11l.06-.08a.24.24,0,0,1,.09-.06.26.26,0,0,1,.21,0,.24.24,0,0,1,.09.06.24.24,0,0,1,.08.19.19.19,0,0,1,0,.1.41.41,0,0,1,0,.09l-.09,0a.15.15,0,0,1-.11,0",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    className: "cls-3",
    d: "M93.25,107.43a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27m0-1.88a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27m0-1.87a.27.27,0,1,1,.27.27.27.27,0,0,1-.27-.27",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    className: "cls-3",
    d: "M93.52,102.07a.27.27,0,0,1-.19-.08.48.48,0,0,1-.08-.19.17.17,0,0,1,0-.1.31.31,0,0,1,0-.1l.09,0a.26.26,0,0,1,.21,0l.09,0,.06.1a.3.3,0,0,1,0,.1.36.36,0,0,1,0,.1.35.35,0,0,1-.06.09.27.27,0,0,1-.19.08",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    className: "cls-3",
    d: "M93.52,109.57a.12.12,0,0,1-.1,0l-.09,0-.06-.09a.36.36,0,0,1,0-.1.36.36,0,0,1,0-.11l.06-.08a.24.24,0,0,1,.09-.06.26.26,0,0,1,.21,0,.24.24,0,0,1,.09.06.24.24,0,0,1,.08.19.19.19,0,0,1,0,.1.41.41,0,0,1,0,.09l-.09,0a.15.15,0,0,1-.11,0",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    className: "cls-3",
    d: "M93.25,111.28a.3.3,0,0,1,.27-.27.27.27,0,0,1,.27.27.25.25,0,0,1-.26.27h0a.27.27,0,0,1-.27-.27",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    className: "cls-3",
    d: "M93.52,113.54a.27.27,0,0,1-.19-.08.41.41,0,0,1,0-.09.2.2,0,0,1,0-.11.19.19,0,0,1,0-.1.41.41,0,0,1,0-.09.28.28,0,0,1,.38,0,.24.24,0,0,1,.06.09.18.18,0,0,1,0,.1.2.2,0,0,1,0,.11.24.24,0,0,1-.06.09.26.26,0,0,1-.19.08",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    className: "cls-3",
    d: "M145.61,113.54a.26.26,0,0,1-.19-.08.37.37,0,0,1-.09-.2.28.28,0,0,1,.46-.19.24.24,0,0,1,.06.09.19.19,0,0,1,0,.1.28.28,0,0,1-.27.28",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    className: "cls-3",
    d: "M145.33,111.28a.3.3,0,0,1,.28-.27.28.28,0,0,1,.27.27.27.27,0,0,1-.27.27h0a.28.28,0,0,1-.28-.27",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    className: "cls-3",
    d: "M145.61,109.57a.22.22,0,0,1-.19-.07.34.34,0,0,1-.09-.2.31.31,0,0,1,.09-.18.26.26,0,0,1,.38,0,.23.23,0,0,1,.08.18.28.28,0,0,1-.08.2.24.24,0,0,1-.19.07",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    className: "cls-3",
    d: "M143.17,109.31a.28.28,0,0,1,.26-.28h0a.28.28,0,0,1,0,.55.27.27,0,0,1-.27-.27h0m-2.18,0a.27.27,0,0,1,.27-.28.28.28,0,0,1,.28.27.28.28,0,0,1-.27.28.28.28,0,0,1-.28-.27h0m-2.17,0a.29.29,0,0,1,.27-.28.28.28,0,1,1,0,.55.29.29,0,0,1-.27-.27m-2.16,0a.27.27,0,0,1,.26-.28h0a.28.28,0,0,1,0,.55.27.27,0,0,1-.27-.27h0m-2.18,0a.27.27,0,0,1,.27-.28.28.28,0,0,1,.28.27.28.28,0,0,1-.27.28h0a.28.28,0,0,1-.27-.27m-2.17,0a.29.29,0,0,1,.27-.28.28.28,0,0,1,0,.55.29.29,0,0,1-.27-.27m-2.16,0a.27.27,0,0,1,.26-.28h0a.28.28,0,0,1,0,.55.27.27,0,0,1-.27-.27h0m-2.18,0a.27.27,0,0,1,.27-.28.28.28,0,0,1,.28.27.28.28,0,0,1-.27.28h0a.28.28,0,0,1-.27-.27m-2.17,0a.29.29,0,0,1,.27-.28.28.28,0,0,1,0,.55.29.29,0,0,1-.27-.27m-2.16,0a.27.27,0,0,1,.26-.28h0a.28.28,0,0,1,0,.55.27.27,0,0,1-.27-.27h0m-2.18,0a.28.28,0,0,1,.27-.28.28.28,0,0,1,0,.55.28.28,0,0,1-.27-.27m-2.17,0a.28.28,0,0,1,.27-.28.28.28,0,0,1,0,.55.28.28,0,0,1-.27-.27m-2.16,0a.27.27,0,0,1,.26-.28h0a.28.28,0,0,1,0,.55.27.27,0,0,1-.27-.27h0m-2.18,0a.28.28,0,0,1,.27-.28.28.28,0,0,1,0,.55.28.28,0,0,1-.27-.27m-2.17,0a.28.28,0,0,1,.27-.28.28.28,0,0,1,0,.55.28.28,0,0,1-.27-.27m-2.17,0a.28.28,0,0,1,.27-.28h0a.28.28,0,1,1-.28.28h0m-2.17,0a.27.27,0,0,1,.27-.28.28.28,0,0,1,.28.27.28.28,0,0,1-.27.28h0a.28.28,0,0,1-.27-.27m-2.17,0a.28.28,0,0,1,.27-.28.28.28,0,0,1,0,.55.28.28,0,0,1-.27-.27m-2.17,0a.28.28,0,0,1,.27-.28h0a.28.28,0,0,1,0,.55.28.28,0,0,1-.27-.27h0m-2.17,0a.27.27,0,0,1,.27-.28.28.28,0,0,1,.28.27.28.28,0,0,1-.27.28h0a.28.28,0,0,1-.27-.27m-2.17,0a.27.27,0,1,1,.27.27.28.28,0,0,1-.27-.27h0m-2.17,0a.28.28,0,0,1,.27-.28h0a.28.28,0,1,1,0,.55.28.28,0,0,1-.27-.27h0m-2.17,0a.27.27,0,0,1,.27-.28.28.28,0,0,1,.28.27.28.28,0,0,1-.27.28h0a.28.28,0,0,1-.27-.27",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    className: "cls-3",
    d: "M93.52,109.57a.12.12,0,0,1-.1,0l-.09,0-.06-.09a.36.36,0,0,1,0-.1.36.36,0,0,1,0-.11l.06-.08a.24.24,0,0,1,.09-.06.26.26,0,0,1,.21,0,.24.24,0,0,1,.09.06.24.24,0,0,1,.08.19.19.19,0,0,1,0,.1.41.41,0,0,1,0,.09l-.09,0a.15.15,0,0,1-.11,0",
    transform: "translate(0.04 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    className: "cls-3",
    d: "M176,52.28a32.4,32.4,0,0,0-32.39-32.13H130.23A39.15,39.15,0,0,0,96.29.52h-26v9.93A39.12,39.12,0,0,0,58.08,31.17a33.7,33.7,0,0,0,2.19,67.32H167.5A23.89,23.89,0,0,0,176,52.28",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    className: "cls-4",
    d: "M176,52.28a32.4,32.4,0,0,0-32.39-32.13H130.23A39.15,39.15,0,0,0,96.29.52h-26v9.93A39.12,39.12,0,0,0,58.08,31.17a33.7,33.7,0,0,0,2.19,67.32H167.5A23.89,23.89,0,0,0,176,52.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    className: "cls-3",
    d: "M150,52.28a32.39,32.39,0,0,0-44.53-29.77A39.16,39.16,0,0,0,32,31.17a33.7,33.7,0,0,0,2.19,67.32H141.46A23.89,23.89,0,0,0,150,52.28",
    transform: "translate(0.04 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M176,52.28a32.4,32.4,0,0,0-44.52-29.77,39.16,39.16,0,0,0-73.41,8.66,33.7,33.7,0,0,0,2.19,67.32H167.5A23.89,23.89,0,0,0,176,52.28",
    transform: "translate(0.04 0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    className: "cls-3",
    d: "M141.46,99H34.23a34.22,34.22,0,0,1-2.62-68.34,39.68,39.68,0,0,1,74.09-8.84,32.93,32.93,0,0,1,44.79,30.08,24.42,24.42,0,0,1-9,47.1m-71.21-98A38.85,38.85,0,0,0,32.54,31.29a.53.53,0,0,1-.47.41A33.17,33.17,0,0,0,34.23,98H141.46a23.37,23.37,0,0,0,8.32-45.2.52.52,0,0,1-.34-.48A31.86,31.86,0,0,0,105.64,23a.53.53,0,0,1-.67-.26A38.4,38.4,0,0,0,70.25,1.05",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    className: "cls-4",
    d: "M141.46,99H34.23a34.22,34.22,0,0,1-2.62-68.34,39.68,39.68,0,0,1,74.09-8.84,32.93,32.93,0,0,1,44.79,30.08,24.42,24.42,0,0,1-9,47.1m-71.21-98A38.85,38.85,0,0,0,32.54,31.29a.53.53,0,0,1-.47.41A33.17,33.17,0,0,0,34.23,98H141.46a23.37,23.37,0,0,0,8.32-45.2.52.52,0,0,1-.34-.48A31.86,31.86,0,0,0,105.64,23a.53.53,0,0,1-.67-.26A38.4,38.4,0,0,0,70.25,1.05",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    className: "cls-35",
    d: "M56.58,50.71h8.61a2.39,2.39,0,0,1,2.4,2.4V95.57a2.4,2.4,0,0,1-2.4,2.4H56.58Z",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    className: "cls-4",
    d: "M57.44,50.71H38.9a2.4,2.4,0,0,0-2.41,2.4h0V95.57A2.41,2.41,0,0,0,38.9,98H57.44a2.41,2.41,0,0,0,2.4-2.4V53.11a2.4,2.4,0,0,0-2.4-2.4h0",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    className: "cls-35",
    x: 36.53,
    y: 88.17,
    width: 23.35,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    className: "cls-35",
    x: 36.53,
    y: 78.8,
    width: 23.35,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    className: "cls-35",
    x: 36.53,
    y: 69.44,
    width: 23.35,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    className: "cls-35",
    x: 36.53,
    y: 60.07,
    width: 23.35,
    height: 0.44
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    className: "cls-3",
    d: "M48.14,57H40.33a.9.9,0,0,0,0,1.79h7.81a.9.9,0,0,0,0-1.79",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    className: "cls-3",
    d: "M48.14,54.72H40.33a.89.89,0,0,0,0,1.78h7.81a.89.89,0,0,0,0-1.78",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    className: "cls-3",
    d: "M48.14,52.4H40.33a.89.89,0,0,0,0,1.78h7.81a.89.89,0,0,0,0-1.78",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    className: "cls-39",
    x: 49.88,
    y: 57.03,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    className: "cls-3",
    x: 49.88,
    y: 54.72,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    className: "cls-39",
    x: 49.88,
    y: 52.4,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    className: "cls-39",
    x: 53.68,
    y: 57.03,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    className: "cls-39",
    x: 53.68,
    y: 54.72,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    className: "cls-3",
    x: 53.68,
    y: 52.4,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    className: "cls-39",
    d: "M48.13,66.4h-7.8a.89.89,0,1,0,0,1.78h7.8a.89.89,0,1,0,0-1.78",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    className: "cls-3",
    d: "M48.14,64.08H40.33a.89.89,0,1,0,0,1.78h7.81a.89.89,0,1,0,0-1.78",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    className: "cls-3",
    d: "M48.14,61.76H40.33a.9.9,0,0,0,0,1.79h7.81a.9.9,0,0,0,0-1.79",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    className: "cls-39",
    x: 49.88,
    y: 66.4,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    className: "cls-39",
    x: 49.88,
    y: 64.08,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    className: "cls-3",
    x: 49.88,
    y: 61.76,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    className: "cls-39",
    x: 53.68,
    y: 66.4,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    className: "cls-39",
    x: 53.68,
    y: 64.08,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    className: "cls-39",
    x: 53.68,
    y: 61.76,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    className: "cls-3",
    d: "M48.14,75.76H40.33a.9.9,0,0,0,0,1.79h7.81a.9.9,0,0,0,0-1.79",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    className: "cls-3",
    d: "M48.14,73.44H40.33a.9.9,0,0,0,0,1.79h7.81a.9.9,0,0,0,0-1.79",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    className: "cls-3",
    d: "M48.14,71.13H40.33a.89.89,0,0,0,0,1.78h7.81a.89.89,0,0,0,0-1.78",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    className: "cls-39",
    x: 49.88,
    y: 75.76,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    className: "cls-3",
    x: 49.88,
    y: 73.45,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    className: "cls-39",
    x: 49.88,
    y: 71.13,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    className: "cls-39",
    x: 53.68,
    y: 75.76,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    className: "cls-39",
    x: 53.68,
    y: 73.45,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    className: "cls-3",
    x: 53.68,
    y: 71.13,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    className: "cls-3",
    d: "M48.14,85.13H40.33a.89.89,0,0,0,0,1.78h7.81a.89.89,0,0,0,0-1.78",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    className: "cls-3",
    d: "M48.14,82.81H40.33a.89.89,0,0,0,0,1.78h7.81a.89.89,0,0,0,0-1.78",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    className: "cls-3",
    d: "M48.14,80.49H40.33a.9.9,0,0,0,0,1.79h7.81a.9.9,0,0,0,0-1.79",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    className: "cls-39",
    x: 49.88,
    y: 85.13,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    className: "cls-3",
    x: 49.88,
    y: 82.81,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    className: "cls-39",
    x: 49.88,
    y: 80.49,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    className: "cls-3",
    x: 53.68,
    y: 85.13,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    className: "cls-39",
    x: 53.68,
    y: 82.81,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    className: "cls-3",
    x: 53.68,
    y: 80.49,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    className: "cls-3",
    d: "M48.14,94.49H40.33a.9.9,0,0,0,0,1.79h7.81a.9.9,0,0,0,0-1.79",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    className: "cls-3",
    d: "M48.14,92.17H40.33a.9.9,0,0,0,0,1.79h7.81a.9.9,0,0,0,0-1.79",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    className: "cls-3",
    d: "M48.14,89.86H40.33a.89.89,0,1,0,0,1.78h7.81a.89.89,0,1,0,0-1.78",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    className: "cls-3",
    x: 49.88,
    y: 94.49,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    className: "cls-39",
    x: 49.88,
    y: 92.18,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    className: "cls-39",
    x: 49.88,
    y: 89.86,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    className: "cls-39",
    x: 53.68,
    y: 94.49,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    className: "cls-39",
    x: 53.68,
    y: 92.18,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    className: "cls-3",
    x: 53.68,
    y: 89.86,
    width: 3.26,
    height: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    className: "cls-35",
    d: "M90.22,28.39H102.9a3.53,3.53,0,0,1,3.53,3.54v62.5A3.54,3.54,0,0,1,102.9,98H90.22Z",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    className: "cls-4",
    d: "M91.48,28.39H64.19a3.54,3.54,0,0,0-3.54,3.54v62.5A3.55,3.55,0,0,0,64.19,98H91.48A3.54,3.54,0,0,0,95,94.43V31.93a3.53,3.53,0,0,0-3.54-3.54",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    className: "cls-35",
    x: 60.69,
    y: 83.54,
    width: 34.37,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    className: "cls-35",
    x: 60.69,
    y: 69.75,
    width: 34.37,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    className: "cls-35",
    x: 60.69,
    y: 55.96,
    width: 34.37,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    className: "cls-35",
    x: 60.69,
    y: 42.18,
    width: 34.37,
    height: 0.65
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    className: "cls-3",
    d: "M77.79,37.7H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    className: "cls-3",
    d: "M77.79,34.29H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    className: "cls-3",
    d: "M77.79,30.88H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    className: "cls-39",
    x: 80.34,
    y: 37.7,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    className: "cls-3",
    x: 80.34,
    y: 34.29,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    className: "cls-39",
    x: 80.34,
    y: 30.88,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    className: "cls-39",
    x: 85.93,
    y: 37.7,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    className: "cls-39",
    x: 85.93,
    y: 34.29,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    className: "cls-3",
    x: 85.93,
    y: 30.88,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    className: "cls-3",
    d: "M77.79,51.49H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    className: "cls-3",
    d: "M77.79,48.08H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    className: "cls-3",
    d: "M77.79,44.67H66.29a1.31,1.31,0,1,0,0,2.62h11.5a1.31,1.31,0,0,0,0-2.62",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_740",
    "data-name": "Rectangle 740",
    className: "cls-39",
    x: 80.34,
    y: 51.49,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    className: "cls-39",
    x: 80.34,
    y: 48.08,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    className: "cls-3",
    x: 80.34,
    y: 44.67,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    className: "cls-3",
    x: 85.93,
    y: 51.49,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    className: "cls-39",
    x: 85.93,
    y: 48.08,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    className: "cls-3",
    x: 85.93,
    y: 44.67,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    className: "cls-3",
    d: "M77.79,65.28H66.29a1.31,1.31,0,1,0,0,2.62h11.5a1.31,1.31,0,0,0,0-2.62",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    className: "cls-3",
    d: "M77.79,61.87H66.29a1.31,1.31,0,0,0,0,2.62h11.5a1.31,1.31,0,0,0,0-2.62",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    className: "cls-3",
    d: "M77.79,58.45H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_749",
    "data-name": "Rectangle 749",
    className: "cls-3",
    x: 80.34,
    y: 65.28,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    className: "cls-39",
    x: 80.34,
    y: 61.87,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_751",
    "data-name": "Rectangle 751",
    className: "cls-39",
    x: 80.34,
    y: 58.45,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_752",
    "data-name": "Rectangle 752",
    className: "cls-39",
    x: 85.93,
    y: 65.28,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    className: "cls-39",
    x: 85.93,
    y: 61.87,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_754",
    "data-name": "Rectangle 754",
    className: "cls-3",
    x: 85.93,
    y: 58.45,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    className: "cls-3",
    d: "M77.79,79.06H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    className: "cls-39",
    d: "M77.79,75.65H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    className: "cls-3",
    d: "M77.79,72.24H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    className: "cls-39",
    x: 80.34,
    y: 79.06,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    className: "cls-3",
    x: 80.34,
    y: 75.65,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    className: "cls-39",
    x: 80.34,
    y: 72.24,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    className: "cls-3",
    x: 85.93,
    y: 79.06,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    className: "cls-3",
    x: 85.93,
    y: 75.65,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    className: "cls-39",
    x: 85.93,
    y: 72.24,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    className: "cls-3",
    d: "M77.79,92.85H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    className: "cls-3",
    d: "M77.79,89.44H66.29a1.32,1.32,0,0,0,0,2.63h11.5a1.32,1.32,0,0,0,0-2.63",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    className: "cls-3",
    d: "M77.79,86H66.29a1.31,1.31,0,1,0,0,2.62h11.5a1.31,1.31,0,0,0,0-2.62",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    className: "cls-39",
    x: 80.34,
    y: 92.85,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    className: "cls-39",
    x: 80.34,
    y: 89.44,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    className: "cls-39",
    x: 80.34,
    y: 86.03,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    className: "cls-39",
    x: 85.93,
    y: 92.85,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    className: "cls-39",
    x: 85.93,
    y: 89.44,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    className: "cls-3",
    x: 85.93,
    y: 86.03,
    width: 4.8,
    height: 2.63
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    className: "cls-35",
    d: "M121.76,37.45h11a3.08,3.08,0,0,1,3.08,3.08h0V94.89A3.08,3.08,0,0,1,132.78,98h-11Z",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    className: "cls-4",
    d: "M122.85,37.45H99.12A3.08,3.08,0,0,0,96,40.53V94.89A3.08,3.08,0,0,0,99.12,98h23.73a3.08,3.08,0,0,0,3.08-3.08V40.53a3.08,3.08,0,0,0-3.08-3.08",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    className: "cls-35",
    x: 96.07,
    y: 85.42,
    width: 29.89,
    height: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    className: "cls-35",
    x: 96.07,
    y: 73.43,
    width: 29.89,
    height: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    className: "cls-35",
    x: 96.07,
    y: 61.43,
    width: 29.89,
    height: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    className: "cls-35",
    x: 96.07,
    y: 49.44,
    width: 29.89,
    height: 0.56
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    className: "cls-3",
    d: "M110.94,45.55h-10a1.15,1.15,0,0,0,0,2.29h10a1.15,1.15,0,1,0,0-2.29",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    className: "cls-3",
    d: "M110.94,42.59h-10a1.14,1.14,0,1,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    className: "cls-3",
    d: "M110.94,39.62h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    className: "cls-39",
    x: 113.17,
    y: 87.58,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    className: "cls-3",
    x: 113.17,
    y: 90.55,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    className: "cls-39",
    x: 113.17,
    y: 93.52,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    className: "cls-39",
    x: 118.03,
    y: 87.58,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    className: "cls-39",
    x: 118.03,
    y: 90.55,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    className: "cls-3",
    x: 118.03,
    y: 93.52,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    className: "cls-39",
    d: "M110.94,57.54h-10a1.15,1.15,0,0,0,0,2.29h10a1.15,1.15,0,1,0,0-2.29",
    transform: "translate(0.04 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    className: "cls-3",
    d: "M110.94,54.58h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    className: "cls-3",
    d: "M110.94,51.61h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    className: "cls-39",
    x: 113.17,
    y: 75.59,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    className: "cls-39",
    x: 113.17,
    y: 78.56,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    className: "cls-3",
    x: 113.17,
    y: 81.53,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    className: "cls-3",
    x: 118.03,
    y: 75.59,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    className: "cls-39",
    x: 118.03,
    y: 78.56,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    className: "cls-3",
    x: 118.03,
    y: 81.53,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    className: "cls-3",
    d: "M110.94,69.54h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    className: "cls-3",
    d: "M110.94,66.57h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    className: "cls-3",
    d: "M110.94,63.6h-10a1.14,1.14,0,1,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    className: "cls-3",
    x: 113.17,
    y: 63.6,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    className: "cls-39",
    x: 113.17,
    y: 66.57,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    className: "cls-39",
    x: 113.17,
    y: 69.54,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    className: "cls-39",
    x: 118.03,
    y: 63.6,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    className: "cls-39",
    x: 118.03,
    y: 66.57,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    className: "cls-3",
    x: 118.03,
    y: 69.54,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    className: "cls-3",
    d: "M110.94,81.53h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    className: "cls-3",
    d: "M110.94,78.56h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,0,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    className: "cls-3",
    d: "M110.94,75.59h-10a1.15,1.15,0,0,0,0,2.29h10a1.15,1.15,0,1,0,0-2.29",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    className: "cls-39",
    x: 113.17,
    y: 51.61,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    className: "cls-3",
    x: 113.17,
    y: 54.58,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    className: "cls-39",
    x: 113.17,
    y: 57.54,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    className: "cls-3",
    x: 118.03,
    y: 51.61,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    className: "cls-39",
    x: 118.03,
    y: 54.58,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    className: "cls-39",
    x: 118.03,
    y: 57.54,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    className: "cls-3",
    d: "M110.94,93.52h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,1,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    className: "cls-3",
    d: "M110.94,90.55h-10a1.14,1.14,0,0,0,0,2.28h10a1.14,1.14,0,0,0,0-2.28",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    className: "cls-3",
    d: "M110.94,87.58h-10a1.15,1.15,0,0,0,0,2.29h10a1.15,1.15,0,0,0,0-2.29",
    transform: "translate(0.04 0)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    className: "cls-3",
    x: 113.17,
    y: 39.62,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    className: "cls-39",
    x: 113.17,
    y: 42.59,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    className: "cls-39",
    x: 113.17,
    y: 45.55,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    className: "cls-39",
    x: 118.03,
    y: 39.62,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    className: "cls-39",
    x: 118.03,
    y: 42.59,
    width: 4.17,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    className: "cls-3",
    x: 118.03,
    y: 45.55,
    width: 4.17,
    height: 2.28
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDb);
export default __webpack_public_path__ + "static/media/cloud-db.2fc86831523d4237da6cf1f3027ca21b.svg";
export { ForwardRef as ReactComponent };